module.exports = __webpack_public_path__ + "static/media/workflux-register.0357a281.svg";